<template>
  <div class="negotiation-item">
    <!-- 左侧图片 -->
    <van-image
      class="item-image"
      radius="8px"
      :src="item.goodsImage"
      fit="cover"
    />

    <!-- 右侧内容区 -->
    <div class="item-content">
      <!-- 顶部信息行 -->
      <div class="left">
        <div class="top-info">
          <!-- 快单 -->
          <img
            width="45px"
            height="25px"
            v-if="isFastTrade"
            :src="require('@/img/pc/follow/fastOrder.png')"
            :alt="$t('mobileOrder.fastOrder')"
          />
          <!-- 标签 -->
          <div v-else class="custom-tag-pc" :class="tagClass">
            {{ tagText }}
          </div>
          <!-- 产品名称 -->
          <div class="goods-name">{{ item.goodsName }}</div>
        </div>

        <!-- 中间信息列表 -->
        <div class="middle-info">
          <div
            class="info-row"
            v-for="(person, index) in item.peopleList"
            :key="index"
          >
            <template v-if="person.phone">
              <img
                v-if="changeIcon(person.text)"
                :src="require('@/img/follow/user.png')"
                class="user"
              />
              <img
                v-else
                :src="require('@/img/follow/staff.png')"
                class="staff"
              />

              <!-- ： -->
              <span class="label">{{ person.text }}{{ $t("pcOrder.personLabelSeparator") }}</span>
              <span class="value"
                >{{ person.name }} |
                <span style="color: #4286f5">{{ person.phone }}</span></span
              >
            </template>
          </div>
        </div>

        <!-- <div class="middle-info">

          <div class="info-row">
          <span class="label">货主：</span>
          <span class="value"
            >{{ item.ownerName }} | {{ item.ownerMobile }}</span
          >
        </div>
          <div class="info-row">
            <span class="label">采购谈判人：</span>
            <span class="value"
              >{{ item.sellerNegotiator }} | {{ item.sellerMobile }}</span
            >
          </div>
        </div> -->
        <!-- 底部按钮区 -->
        <div class="bottom-buttons">
          <template v-if="type === 'tprGetFollow'">
            <el-button @click="blockTprGetFollow(item)"> 屏蔽该信息 </el-button>
            <el-button type="primary" @click="handlerTprGetFollow(item)">
              抢单
            </el-button>
          </template>
          <template v-else>
            <!-- 查看详情 -->
            <el-button v-if="!fbhy" @click="viewDetail(item)">
              {{ $t("buyOrders.viewDetails") }}
            </el-button>
            <template v-if="!isFastTrade">
              <!-- 发布货源 -->
              <el-button v-if="fbhy" type="primary" @click="navigateToPublish">
                {{ $t("sourcePublish.postSupply") }}
              </el-button>
              <el-button
                v-if="xggmyxd"
                type="primary"
                @click="navigateToEditPreOrder"
              >
                修改购买意向单
              </el-button>
              <el-button
                v-if="qryxd"
                type="primary"
                @click="navigateToConfirmPreOrder"
              >
                确认意向单
              </el-button>
            </template>
          </template>
        </div>
      </div>

      <div class="right">
        <!-- 价格区域 -->
        <div class="price-area">
          <div class="flex ju_end">
            <div
              class="price-title"
              v-if="type === 'tprGetFollow' || fbhy || xggmyxd"
            >
              信息价格
            </div>
            <div class="price">{{ $formatPrice(item.goodsPrice) }}</div>
            <!-- priceUnit2 -->
            <!-- 元 -->
            <div class="currency">
              <span v-if="item.goodsPriceUnit == 10">美</span>{{ $t("pcPublish.yuan") }}
            </div>
          </div>
          <!-- 美元 -->
          <!-- 元 -->
          <div class="quantity" v-if="item.originalGoodsPrice">
            <!-- 商品原价 -->
            <span
              class="count"
              v-if="type === 'tprGetFollow' || fbhy || xggmyxd"
              >{{ $t("transactionDetail.originalPrice") }}</span
            >
            {{ $formatPrice(item.originalGoodsPrice) }}
            <span>{{ item.goodsPriceUnit == 10 ? $t("marketComponents.usDollar") : $t("pcPublish.yuan") }}</span>
          </div>
          <div class="quantity">
            <!-- 信息 -->
            <!-- 数量 -->
            <span class="count"
              ><span v-if="type === 'tprGetFollow' || fbhy || xggmyxd"
                >{{ $t("pcCsHome.information") }}</span
              >{{ $t("pcBrand.quantity") }}</span
            >
            {{ item.goodsQuantity }}
            <span style="color: #000">{{ item.goodsUnit }}</span>
          </div>
        </div>
        <!-- 时间信息 -->
        <div class="create-time">
          {{
            type === "tprGetFollow"
              ? $formatTime(item.createTime)
              : $formatTime(item.followTime)
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 标签样式类名
    tagClass() {
      const { type, model, clueType } = this.item;
      // 抢单页面标签逻辑
      if (this.type === "tprGetFollow") {
        return clueType === 1 ? "tag_yellow" : "tag_green";
      }
      // 跟单页面标签逻辑
      const classMap = {
        "10_1": "tag_yellow", // type=10,model=1
        "10_2": "tag_yellow", // type=10,model=2
        "20_1": "tag_blue", // type=20,model=1
        "20_2": "tag_green", // type=20,model=2
        "30_1": "tag_blue", // type=30,model=1
        "30_2": "tag_green", // type=30,model=2
      };
      return classMap[`${type}_${model}`] || "";
    },
    // 标签文本内容
    tagText() {
      const { type, model, clueType } = this.item;
      // 抢单页面标签文本
      if (this.type === "tprGetFollow") {
        return clueType === 1 ? "货源信息" : "求购信息";
      }
      // 跟单页面标签文本
      const textMap = {
        "10_1": "货源线索谈判人",
        "10_2": "求购线索谈判人",
        "20_1": "货源商品谈判人",
        "20_2": "购买商品谈判人",
        "30_1": "交易采购谈判人",
        "30_2": "交易销售谈判人",
      };

      return textMap[`${type}_${model}`] || "";
    },
    isFastTrade() {
      return this.item.clueId == -1 && this.type !== "tprGetFollow";
    },
    // 发布货源
    fbhy() {
      return this.item.type === 10 && this.item.status === 1;
    },
    // 修改购买意向单
    xggmyxd() {
      return (
        this.item.type === 30 && this.item.status === 1 && this.item.model == 2
      );
    },
    // 确认意向单
    qryxd() {
      return (
        this.item.type === 30 && this.item.status === 1 && this.item.model == 1
      );
    },
  },
  methods: {
    changeIcon(text) {
      if (
        text == "买家" ||
        text == "货主" ||
        text == "货主信息提供人" ||
        text == "买家信息提供人"
      )
        return true; // 买家、货主、货主信息提供人、买家信息提供人的图标
    },
    viewDetail(item) {
      this.$router.push({
        path: `/follow/tprFollowDetail/${item.id}`, // 原有的路径参数
        query: {
          clueId: item.clueId,
        },
      });
    },
    // 抢单
    handlerTprGetFollow(item) {
      this.$emit("tpr-get-follow", item);
    },
    // 屏蔽该信息
    blockTprGetFollow(item) {
      this.$emit("tpr-block-follow", item);
    },
    navigateToPublish() {
      this.$router.push({
        path: "/source/publishGoods",
        query: { id: this.item.clueId },
      });
    },
    navigateToEditPreOrder() {
      this.$router.push({
        path: "/follow/tpr/editPreOrder",
        query: { orderId: this.item.preOrderId, followId: this.item.id },
      });
    },
    navigateToConfirmPreOrder() {
      this.$router.push({
        path: "/follow/tpr/confirmPreOrder",
        query: { orderId: this.item.preOrderId, followId: this.item.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.negotiation-item {
  display: flex;
  gap: 28px;
  padding: 36px 0;
  border-bottom: 1px solid #eee;

  .item-image {
    width: 220px;
    height: 180px;
    flex-shrink: 0;
  }

  .item-content {
    display: flex;
    flex: 1;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;

      // 头部信息区域
      .top-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .goods-name {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 22px;
          font-weight: 700;
          margin-left: 8px;
        }
      }
      // 中间联系人区域
      .middle-info {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .info-row {
          display: flex;
          align-items: center;
          gap: 6px;
          .user {
            width: 16px;
            height: 16px;
          }
          .staff {
            width: 18px;
            height: 18px;
          }

          .label {
            color: #999;
          }

          .value {
            flex: 1;
          }
        }
      }
      // 按钮区域
      .bottom-buttons {
        display: flex;
        gap: 10px;

        .el-button {
          border-radius: 8px !important;
          font-size: 18px !important;
          padding: 10px 52px !important;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // 价格区域
      .price-area {
        text-align: right;

        .price {
          font-size: 36px;
          font-weight: bold;
          color: #1890ff;
        }
        .price-title {
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          margin-right: 4px;
        }

        .currency,
        .quantity {
          font-size: 14px;
          color: #1890ff;
        }

        .currency {
          margin-top: 20px;
          margin-left: 4px;
        }

        .quantity {
          margin-top: 8px;
          display: flex;
          justify-content: flex-end;
          gap: 4px;
          .count {
            color: #999;
          }
        }
      }

      // 时间区域
      .create-time {
        font-size: 14px;
        color: #999;
        text-align: right;
      }
    }
  }
}
</style>
